import { styled } from '@mui/material/styles';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';

export const WarningIcon = styled(ReportProblemOutlinedIcon)(({ theme }) => ({
  marginRight: theme.spacing(1),
  color: '#ff9800',
}));
